@if (enableNavigationBar) {
	<app-navigation-header id="headerContainer"></app-navigation-header>
	<!-- top navigation space-->
	<div style="height:70px; display:table; table-layout:fixed; background-color:transparent"></div>
}
<div id="viewTemp" class="h-100 w-100">
	<router-outlet></router-outlet>
</div>
@if (enableNavigationBar) {
	<app-navigation-footer id="footerContainer"></app-navigation-footer>
}
@if (enableIdleTimeout) {
	<app-idle></app-idle>
}
